import type { NestedFilterKeys } from '@dresscode-frontend/utility-types';
import type { ColumnDef } from '@tanstack/react-table';
import { DataTableColumnHeader } from '@/components/DataTable/Columns/DataTableColumnHeader';
import type { HelperOptions } from '@/components/DataTable/types';
import Icon from '@/components/Icon/Icon';

/**
 * チェックマークを表示するカラム
 * true の場合はチェックマークを表示し、true以外の場合は "-" を表示します
 */
export function checkMarkColumn<TData>(id: NestedFilterKeys<TData, boolean> & string, helperOptions: HelperOptions): ColumnDef<TData> {
  const {
    minWidth = '200px',
    sortable = true
  } = helperOptions;
  return {
    accessorKey: id,
    enableSorting: sortable,
    meta: {
      i18nKey: helperOptions.i18nKey,
      thStyle: {
        minWidth
      }
    },
    header: DataTableColumnHeader,
    cell: function Cell({
      getValue
    }) {
      const value = getValue();
      const isChecked = value === true;
      if (isChecked) {
        return <Icon iconName="Check" />;
      }
      return <div className="text-sm">-</div>;
    }
  } satisfies ColumnDef<TData>;
}